import { render, staticRenderFns } from "./CoachDetailModal.vue?vue&type=template&id=6de4c934"
import script from "./CoachDetailModal.vue?vue&type=script&lang=js"
export * from "./CoachDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports